import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setGlobalKpi = (state, { globalFactory }) => {
  if (!globalFactory) return state;
  return state.merge({ globalFactory });
};

const setGlobalDashboard = (state, { globalDashboardResult }) => {
  if (!globalDashboardResult) return state;
  return state.merge({ globalDashboardResult });
};

const setFactoryConfig = (state, { factoryConfigResult }) => {
  if (!factoryConfigResult) return state;
  return state.merge({ factoryConfigResult });
};

const setReleaseVersion = (state, { versionData }) => {
  if (!versionData) return state;
  return state.merge({ versionData });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
export const callbacks = [
  {
    actionType: ActionTypes.SET_GLOBAL_FACTORY,
    actionFunction: setGlobalKpi,
  },
  {
    actionType: ActionTypes.SET_GLOBAL_DASHBOARD,
    actionFunction: setGlobalDashboard,
  },
  {
    actionType: ActionTypes.SET_FACTORY_CONFIG,
    actionFunction: setFactoryConfig,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_RELEASE_VERSION,
    actionFunction: setReleaseVersion,
  },
];
